var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none"}},[_c('rect',{attrs:{"x":"0.5","y":"0.500244","width":"14","height":"14","rx":"7","stroke":"#BCC0CB"}})])}
var staticRenderFns = []

export { render, staticRenderFns }